module.exports = __webpack_public_path__ + "static/media/emma_vp_vologda_1.da02ced2.jpg";